import i18n from '@/lang'
import CommonTopicService from '@/services/CommonTopicService'
import {getModule} from "vuex-module-decorators";
import UserInfo from "@/store/modules/UserInfo";
import store from "@/store";

const UserModule = getModule(UserInfo, store)

enum MENU_TYPE {
  COMPANY_ANNOUNCEMENT = 3,
  EMPLOYEE_POINT = 4
}

export const fetchCommonTopicAvatar = async (): Promise<{
  avatar: string
  title: string
}> => {
  let avatar = require('@/assets/images/logo-cast-gram.svg')
  let title = i18n.t('common.title.common_topic').toString()

  try {
    const res = await CommonTopicService.getCommonTopicMenu()

    if (res.status === 200) {
      const item = res.data?.find(
        (i: any) => i.type_display === MENU_TYPE.COMPANY_ANNOUNCEMENT
      )
      if (item?.icon_image_path) {
        avatar = item.icon_image_path
      }

      if (item?.logo_company_from_s3) {
        UserModule.HANDLE_COMPANY_DEFAULT_LOGO(item.logo_company_from_s3)
      }

      if (item?.title) {
        // handle to remove HTML tags from exist data (abc <br /> xyz => abc xyz)
        const clean = item.title
          .replace(/<br\s*\/?>/gi, '') // specifically replace <br> tags
          // .replace(/<[^>]*>/g, ' ') // Alternative to remove all HTML tags
          .trim()
        title = clean
      }
    }
  } catch (error) {
    console.error('Failed to fetch common topic avatar', error)
  }

  return { avatar, title }
}
